import { useState } from "react";
import { format, parse } from "date-fns";
import { Calendar as CalendarIcon, X } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

/** Shadcn calendar picker bound to a "YYYY-MM-DD" string value. */
export function DatePicker({ value, onChange, placeholder = "Pick a date", testId, clearable = true, disabled }) {
  const [open, setOpen] = useState(false);
  let date;
  if (value) {
    const d = parse(value, "yyyy-MM-dd", new Date());
    if (!Number.isNaN(d.getTime())) date = d;
  }
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          data-testid={testId}
          className={cn(
            "w-full justify-start text-left font-normal",
            !date && "text-muted-foreground",
          )}
        >
          <CalendarIcon className="mr-2 size-4" />
          {date ? format(date, "dd MMM yyyy") : placeholder}
          {clearable && date && (
            <span
              role="button"
              tabIndex={-1}
              data-testid={testId ? `${testId}-clear` : undefined}
              className="ml-auto text-muted-foreground hover:text-foreground"
              onClick={(e) => {
                e.stopPropagation();
                onChange("");
              }}
            >
              <X className="size-3.5" />
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={date}
          disabled={disabled}
          onSelect={(d) => {
            onChange(d ? format(d, "yyyy-MM-dd") : "");
            setOpen(false);
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
